const add = {
  path: 'add',
  component: resolve => require(['../../../../../pages/admin/merchant/add'], resolve),
  meta: {
    requireAuth: true
  }
}

export default add
